import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ClipBoardService } from '../../../services/clipboard.service'
import { ServerService } from '../../../services/server.service'
import { IMyDateRangeModel, IMyDrpOptions } from 'mydaterangepicker';

@Component({
  selector: 'app-export-call-recording',
  templateUrl: './export-call-recording.component.html',
  encapsulation:ViewEncapsulation.None,
  styleUrls: ['./export-call-recording.component.scss']
})
export class ExportCallRecordingComponent implements OnInit {

  public authToken = localStorage.getItem("token");
  public projectInfo = JSON.parse(sessionStorage.getItem('projectInfo'));
  userInfo: any = JSON.parse(localStorage.getItem("userInfo"))
  action = "";
  selectedVendor: any = ""
  vendors: any[] = []
  createdDate: any = ""
  user_id:any;

  lastVendorStatusModifiedDate: any = ""
  lastClientStatusModifiedDate: any = ""
  createdAt: any = ""
  filterByClientUser:any
  selectStatus: any = []
  leadStatuses: any = []
  isMaster: boolean = false

  users: any[] = []
///File Name

callerNameCheckBox = false;
timeStampcheckedBox = false;
leadStatusCheckedBox = false;

///

  myDateRangePickerOptions = {     
      dateFormat: 'dd.mm.yyyy'      
  };
  
  constructor(
      private serverService: ServerService,
      private clipBoardService: ClipBoardService,
      private dialogRef: MatDialogRef<ExportCallRecordingComponent>,
      @Inject(MAT_DIALOG_DATA) private data
  ) {
     
  }

  ngOnInit() {
    //  console.log(this.data)
     this.getUsers()
  }

  getUsers() {
      this.serverService.usersList(this.authToken).subscribe(
          data => {
              this.users = data.users;
          },
          err => {
              this.clipBoardService.checkServerError(err, localStorage.getItem("token"))
          }
      )
  }

  exportCallRecords() {
    // debugger;
    // console.log(this.createdAt)
   let body = {
    'project_id':this.data.project,
    'statuses':this.selectStatus,
    'vendor_assignee_ids':this.user_id,
    'include_caller_name': this.callerNameCheckBox,
    'include_timestamp': this.timeStampcheckedBox,
    'include_lead_status':this.leadStatusCheckedBox,
    'created_at':this.createdAt == ''?[]: [this.createdAt.beginDate.year + '-' + this.createdAt.beginDate.month + '-' + this.createdAt.beginDate.day, this.createdAt.endDate.year + '-' + this.createdAt.endDate.month + '-' + this.createdAt.endDate.day]
   }
  //  console.log(body)
    this.serverService.exportCallRecording(body,this.authToken).subscribe((data)=>{
      // console.log(data)
    this.dialogRef.close(data);
    if(data['message'] != "We didn't found any leads."){
    this.clipBoardService.showMessgeInText("Email Sent Successfully", "success-snackbar");
    }
    else{
      this.clipBoardService.showMessgeInText("We didn't found any leads.", "error-snackbar");
    }
},
err => {
    // this.clipBoardService.checkServerError(err, this.authToken)
    // this.btnStatus = false;
    // console.log(err)
    this.clipBoardService.showMessgeInText("We didn't found any leads.", 'error-snackbar')
    //  this.clipBoardService.showMessgeInText(err, "success-snackbar");
}
    )
  }

  close() {
      this.dialogRef.close();
  }

  clear() {

      // this.lastVendorStatusModifiedDate = ""
      this.selectStatus = []
      this.user_id = []
      // this.lastClientStatusModifiedDate = ""
      this.createdAt = ""
      this.callerNameCheckBox = false;
      this.timeStampcheckedBox = false;
      this.leadStatusCheckedBox = false;
  }
  callerName(event){
    // console.log(event.checked)
    this.callerNameCheckBox = event.checked;

  }
  timeStamp(event){
    this.timeStampcheckedBox = event.checked;
  }
  leadStatusChecked(event){
    this.leadStatusCheckedBox= event.checked;
  }
}
